<template>
  <v-card class="px-2 py-4" @click="clickCard()" elevation="0" tile>
    <div class="d-flex justify-space-between">
      <v-chip :color="statusColors[status]" v-text="status" small dark> </v-chip>
      <span class="align-self-center primary--text" v-text="dateTime"></span>
    </div>

    <div class="mt-2 black--text" v-text="title_en"></div>

    <div class="mt-1 grey--text text--darken-1" v-text="location"></div>

    <div class="d-flex flex-column align-end">
      <div
        class="mt-1 grey--text text--darken-1 font-weight-bold font-italic"
        v-if="speakerName != null"
        v-text="speakerName"
      ></div>
      <div
        class="mt-1 grey--text text--darken-1 font-weight-bold font-italic"
        v-if="sponsorName != null"
        v-text="sponsorName"
      ></div>
    </div>

    <slot name="action" v-bind:content="{ title: title_en, dateTime, location }"></slot>
  </v-card>
</template>

<script>
import apiPerson from "@/apis/Person";
import apiSponsor from "@/apis/Sponsor";
import apiSession from "@/apis/Session";

export default {
  name: "UnitCard",
  props: {
    hasLink: {
      type: Boolean,
      default: true
    },
    id: {
      type: Number,
      required: true
    },
    title_en: {
      type: String
    },
    start_time: {
      type: String
    },
    end_time: {
      type: String
    },
    info: {
      type: String
    },
    session: {
      type: [Object, Number]
    },
    presenter: {
      type: Array
    },
    speaker: {
      type: [Object, Number]
    },
    speaker_sponsor: {
      type: [Object, Number]
    }
  },
  data() {
    return {
      statusColors: {
        Processed: "grey darken-2",
        Processing: "info",
        Upcoming: "primary"
      },
      location: "",
      speakerName: null,
      sponsorName: null,
      presenterName: []
    };
  },
  computed: {
    status() {
      let status = "error";
      const dateTimeNow = this.$dayjs().add(8, "h");

      const dateTimeStart = this.$dayjs(this.start_time);
      const dateTimeEnd = this.$dayjs(this.end_time);

      if (dateTimeNow.isBetween(dateTimeStart, dateTimeEnd, "minute", "[")) {
        status = "Processing";
      } else if (dateTimeNow.isBefore(dateTimeStart)) {
        status = "Upcoming";
      } else if (dateTimeNow.isAfter(dateTimeEnd)) {
        status = "Processed";
      }

      return status;
    },
    dateTime() {
      const date = this.$dayjs(this.start_time)
        .utc()
        .format("YYYY/MM/DD");

      const timeStart = this.$dayjs(this.start_time)
        .utc()
        .format("HH:mm");
      const timeEnd = this.$dayjs(this.end_time)
        .utc()
        .format("HH:mm");

      return `${date} - ${timeStart} ~ ${timeEnd}`;
    }
  },
  methods: {
    clickCard() {
      if (this.hasLink) this.$router.push({ name: "Unit", params: { id: this.id } });
    },
    async getLocation(session) {
      let trackId = null;
      if (typeof session === "number") {
        const params = new URLSearchParams({ populate: false });
        const { track } = await apiSession.get(session, params);
        trackId = track;
      } else {
        trackId = session.track;
      }

      this.location = this.$store.getters.trackName(trackId);
    },
    async getPresenterName(presenterItem) {
      if (presenterItem == null || presenterItem.length === 0) return null;

      let presenter = null;
      if (typeof presenterItem[0] === "number") presenter = await apiPerson.get(presenterItem);
      if (typeof presenterItem[0] === "object") presenter = presenterItem;

      const { name_en, name_zh } = presenter;
      this.presenterName = name_en + (name_zh ? ` (${name_zh})` : "");
    },
    async getSpeakerName(speakerItem) {
      if (speakerItem == null) return null;

      let speaker = null;
      if (typeof speakerItem === "number") speaker = await apiPerson.get(speakerItem);
      if (typeof speakerItem === "object") speaker = speakerItem;

      const { name_en, name_zh } = speaker;
      this.speakerName = name_en + (name_zh ? ` (${name_zh})` : "");
    },
    async getSponsorName(sponsorItem) {
      if (sponsorItem == null) return null;

      let sponsor = null;
      if (typeof sponsorItem === "number") sponsor = await apiSponsor.get(sponsorItem);
      if (typeof sponsorItem === "object") sponsor = sponsorItem;

      const { name_en, name_zh } = sponsor;
      this.sponsorName = name_en + (name_zh ? ` (${name_zh})` : "");
    }
  },
  async mounted() {
    await this.getLocation(this.session);
    this.getPresenterName(this.presenter);
    this.getSpeakerName(this.speaker);
    this.getSponsorName(this.speaker_sponsor);
  }
};
</script>

<style></style>
